import PocketBase from "pocketbase";
import i18n from "@/i18n";
import { env } from "@/lib/platform/env";
import type { TypedPocketBase } from "@/lib/platform/pb-types";
import { translateRefusal } from "@/lib/plan/plan-errors";

/** Single PocketBase client for the whole app. Auth state persists in localStorage. */
export const pb = new PocketBase(env.pocketbaseUrl) as TypedPocketBase;

// React StrictMode + React Query fire duplicate requests; don't let the SDK cancel them.
pb.autoCancellation(false);

// "plan:receipts" from the server becomes a sentence in the person's language.
pb.afterSend = (_response, data) => translateRefusal(data, i18n.t);
